import data from "@/assets/data/pattern.csv";

class Personality {
  constructor(data){
    this.data = data;
  }
  getPattern(answerPattern){
    const data = this.data;
    for(var i = 0; i < data.length; i++){
      if( data[i][0] === answerPattern ){
        return data[i][1];
      }
    }
  }
}
export default new Personality(data);